import { history } from 'services/history.js'

const AUCTION_SCROLL_RESTORE_KEY = 'auctionScrollRestore'

const isModifiedEvent = (event) => (
  event.defaultPrevented
  || event.button !== 0
  || event.metaKey
  || event.altKey
  || event.ctrlKey
  || event.shiftKey
)

export const getAuctionScrollRestoreState = (auctionCode) => ({
  [AUCTION_SCROLL_RESTORE_KEY]: {
    auctionCode,
    scrollY: window.scrollY,
  }
})

export const getAuctionScrollRestore = (location) => (
  location?.state?.[AUCTION_SCROLL_RESTORE_KEY]
)

export const clearAuctionScrollRestore = (location) => {
  if (!getAuctionScrollRestore(location)) return

  const nextState = { ...(location.state || {}) }
  delete nextState[AUCTION_SCROLL_RESTORE_KEY]

  history.replace({
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
    state: Object.keys(nextState).length > 0 ? nextState : undefined,
  })
}

export const navigateFromAuctionToItem = (event, destination, auctionCode) => {
  if (isModifiedEvent(event)) return

  const state = getAuctionScrollRestoreState(auctionCode)

  event.preventDefault()
  event.stopPropagation()

  history.replace({
    pathname: history.location.pathname,
    search: history.location.search,
    hash: history.location.hash,
    state: {
      ...(history.location.state || {}),
      ...state,
    },
  })

  history.push({
    ...destination,
    state,
  })
}
